<template>
  <div class="relative">
    <div class="absolute inset-0 flex items-center" aria-hidden="true">
      <div class="w-full" :class="borderStyling"></div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "UiDivider",
  props: {
    borderStyling: {
      type: String,
      default: "border-t border-gray-200",
    },
  },
};
</script>